import type { Message } from '../types';

/**
 * Check if the client can receive messages.
 */
export const clientCanReceiveMessages = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (
    'ReactNativeWebView' in window &&
    typeof window.ReactNativeWebView === 'object' &&
    window.ReactNativeWebView !== null &&
    'postMessage' in window.ReactNativeWebView &&
    typeof window.ReactNativeWebView.postMessage === 'function'
  ) {
    return true;
  }

  return process.env.NEXT_PUBLIC_CLIENT_MESSAGING_MOCK === 'true';
};

/**
 * Send a message to the client.
 */
export const sendClientMessage = (message: Message) => {
  const data = JSON.stringify(message);

  if (typeof window === 'undefined') {
    return;
  }

  if (
    'ReactNativeWebView' in window &&
    typeof window.ReactNativeWebView === 'object' &&
    window.ReactNativeWebView !== null &&
    'postMessage' in window.ReactNativeWebView &&
    typeof window.ReactNativeWebView.postMessage === 'function'
  ) {
    window.ReactNativeWebView.postMessage(data);
    return;
  }

  if (process.env.NEXT_PUBLIC_CLIENT_MESSAGING_MOCK === 'true') {
    // eslint-disable-next-line no-console
    console.info(`[CLIENT MOCK received message]: ${data}`);
    return;
  }
};
